<template>
  <div>
    <img :src="getStatus(data.status)" />
  </div>
</template>

<script>
import configObject from "../../../config";
import Jquery from "jquery";
let $ = Jquery;
export default {
  data() {
    return {
      data: {},
    };
  },

  methods: {
    getStatus(status) {
      switch (status) {
        case "Processing":
          return require(`../../../assets/img/processing.png`);
        case "Payment Pending":
          return require(`../../../assets/img/payment_pending.png`);
        case "Payment Completed":
          return require(`../../../assets/img/payment_completed.png`);
        case "Payment Confirmed":
          return require(`../../../assets/img/payment_confirmed.png`);
        case "Order Rejected":
          return require(`../../../assets/img/order_rejected.png`);
        case "Order Accepted":
          return require(`../../../assets/img/order_accepted.png`);
        case "Order Completed":
          return require(`../../../assets/img/order_completed.png`);
          case "Driver Assigned":
          return require(`../../../assets/img/driver_assigned.png`);
        case "Fill Started":
          return require(`../../../assets/img/fill_started.png`);
          case "Fill Ended":
          return require(`../../../assets/img/fill_ended.png`);
        case "Owner Accepted":
          return require(`../../../assets/img/processing.png`);
      }
    },
  },
};
</script>

<style scoped>
button {
  background-color: #370f70;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
}
</style>